import ApplicationController from './application_controller';
import log from '../lib/logger';

export default class extends ApplicationController {
  static targets = ['radarChart'];

  // Note: no connect() init here. radarChartTargetConnected fires for targets
  // already present at connection time as well as lazily-added ones, so a
  // connect() call would double-initialize the chart.
  radarChartTargetConnected() {
    // This will be called when the radar chart element is added to the DOM
    this.initializeRadarChart();
  }

  radarChartTargetDisconnected(element) {
    // Remove the resize listener the billing health module stored on
    // #health-score-radar, so Turbo visits don't accumulate window listeners.
    // _resizeHandler is the shared handler-stash convention (see revenue_sankey_controller).
    const radar = element?.querySelector('#health-score-radar');
    /* eslint-disable no-underscore-dangle */
    if (radar && radar._resizeHandler) {
      window.removeEventListener('resize', radar._resizeHandler);
      delete radar._resizeHandler;
    }
    /* eslint-enable no-underscore-dangle */
  }

  initializeRadarChart() {
    // Import and initialize the billing health module
    import('../pages/billing_health')
      .then((module) => {
        // Bail if the target disconnected while the import was in flight
        if (!this.hasRadarChartTarget) return;

        const billingHealth = module.default;
        if (billingHealth !== undefined) {
          billingHealth();
        }
      })
      .catch((error) => {
        log.error('Error loading billing health module:', error);
      });
  }
}
